import {Pipe, PipeTransform} from '@angular/core';
import cdnify from '../../../utils/cdnify';

@Pipe({
  name: 'cdnify'
})

export class CdnifyPipe implements PipeTransform {

  transform(value: string): unknown {
    return cdnify(value);
  }

}
